//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";

// responsive
import { M, T, MMinus } from "../../utils/MT";

export default function InnerCon(props) {
    return <Container>{props.children}</Container>;
}
const Container = styled.main`
    position: relative;
    width: 100%;
    padding-top: calc(100vw * (140 / 1920));
    min-height: 100vh;

    @media screen and (max-width: 1300px) {
        padding-top: calc(100vw * (140 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-top: ${M(51)};
        /* padding-top: ${M(114)}; */
    }
`;
